const breadCrumb = document.querySelector('.breadcrumbs-hero-internal .breadcrumb');
// Last element must be visible so this functions scrolls to the end of the breadcrumb
const scrollToTheEnd = () => breadCrumb ? breadCrumb.scrollLeft = breadCrumb.clientWidth : null;

module.exports = {
  scrollToTheEnd: scrollToTheEnd
}